import { Client, dedupExchange, fetchExchange } from "urql";
import { persistedFetchExchange } from "@urql/exchange-persisted-fetch";
import { cacheExchange } from "@urql/exchange-graphcache";
import { devtoolsExchange } from "@urql/devtools";
import cacheAPIExchange from "./cacheAPIExchange";
import cacheExchangeConfig from "./cacheExchangeConfig";


// urql config
const exchanges = [dedupExchange];

if (process.env.NODE_ENV !== "production") {
  exchanges.unshift(devtoolsExchange);
}

// add schema to client
exchanges.push(cacheExchange(cacheExchangeConfig));

// store responses in browser cache storage if sw if offline
exchanges.push(cacheAPIExchange);

// setup persistent queries - must come before offline exchange
// to avoid queries being cancelled
if (process.env.PERSISTENT_QUERIES === "on") {
  const persistence = persistedFetchExchange({
    preferGetForPersistedQueries: true,
    enforcePersistedQueries: true,
    // simpler generate hash for use with graphql-persisted-document-loader in webpack
    generateHash: (_, document) =>
      new Promise((res) => {
        res(document.id);
      }),
  });

  exchanges.push(persistence);
}

// add fetch last
exchanges.push(fetchExchange);

const client = new Client({
  url: process.env.GRAPHQL_URL,
  exchanges,
  requestPolicy: "cache-and-network", // keep cache up to date
});

export default client;
